var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailToConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94267 2.61855C1.60269 2.93424 1.375 3.44648 1.375 4.25C1.375 4.45711 1.20711 4.625 1 4.625C0.792893 4.625 0.625 4.45711 0.625 4.25C0.625 3.30353 0.897308 2.56576 1.43233 2.06895C1.96232 1.57682 2.69251 1.375 3.5 1.375H8.5C9.30749 1.375 10.0377 1.57682 10.5677 2.06895C11.1027 2.56576 11.375 3.30353 11.375 4.25V7.75C11.375 8.69648 11.1027 9.43424 10.5677 9.93105C10.0377 10.4232 9.30749 10.625 8.5 10.625H3.5C3.29289 10.625 3.125 10.4571 3.125 10.25C3.125 10.0429 3.29289 9.875 3.5 9.875H8.5C9.19251 9.875 9.71232 9.70182 10.0573 9.38145C10.3973 9.06576 10.625 8.55352 10.625 7.75V4.25C10.625 3.44648 10.3973 2.93424 10.0573 2.61855C9.71232 2.29818 9.19251 2.125 8.5 2.125H3.5C2.80749 2.125 2.28768 2.29818 1.94267 2.61855Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79302 4.26597C8.92227 4.42779 8.89587 4.66375 8.73405 4.79301L7.16858 6.04338C6.51688 6.56221 5.47814 6.56221 4.82645 6.04338L4.82552 6.04264L3.26552 4.79264C3.1039 4.66314 3.07787 4.42713 3.20737 4.26551C3.33688 4.10389 3.57288 4.07785 3.7345 4.20736L5.29401 5.45696C5.67232 5.75775 6.32308 5.75768 6.70127 5.45676C6.70121 5.45681 6.70133 5.45671 6.70127 5.45676L8.26598 4.20699C8.42781 4.07774 8.66377 4.10414 8.79302 4.26597Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 8.25C0.625 8.04289 0.792893 7.875 1 7.875H4C4.20711 7.875 4.375 8.04289 4.375 8.25C4.375 8.45711 4.20711 8.625 4 8.625H1C0.792893 8.625 0.625 8.45711 0.625 8.25Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 6.25C0.625 6.04289 0.792893 5.875 1 5.875H2.5C2.70711 5.875 2.875 6.04289 2.875 6.25C2.875 6.45711 2.70711 6.625 2.5 6.625H1C0.792893 6.625 0.625 6.45711 0.625 6.25Z",
    fill: "#292D32"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailToConfirm);
export default __webpack_public_path__ + "static/media/emailToConfirm.8c9560c8.svg";
export { ForwardRef as ReactComponent };